import { render } from "./BillingAddressForm.vue?vue&type=template&id=5a6412cc"
import script from "./BillingAddressForm.vue?vue&type=script&lang=js"
export * from "./BillingAddressForm.vue?vue&type=script&lang=js"

import "./BillingAddressForm.vue?vue&type=style&index=0&id=5a6412cc&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__